import { httpClient } from '@/core/api/http-client';
import type {
  AmazonCounter,
  AmazonFeedDetail,
  AmazonLogsResponse,
  ProcessPointsRequest,
  ProcessPointsResponse,
} from './amazon.types';

export const amazonService = {
  getCounter: async (): Promise<AmazonCounter> => {
    const response = await httpClient.get<AmazonCounter>('/admin/amazon/counter');
    return response.data;
  },

  processPoints: async (body: ProcessPointsRequest): Promise<ProcessPointsResponse> => {
    const response = await httpClient.post<ProcessPointsResponse>('/admin/amazon/points', body);
    return response.data;
  },

  getLogsByPoint: async (
    dispatch_place_id: string,
    filters?: { from?: string; to?: string },
  ): Promise<AmazonLogsResponse> => {
    const response = await httpClient.get<AmazonLogsResponse>(
      `/admin/amazon/logs/${dispatch_place_id}`,
      { params: filters },
    );
    return response.data;
  },

  getFeedDetail: async (feed_id: string): Promise<AmazonFeedDetail> => {
    const response = await httpClient.get<AmazonFeedDetail>(`/admin/amazon/feeds/${feed_id}`);
    return response.data;
  },
};
